// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ContentComponentItemFragmentDoc } from './ContentComponentItem.fragment.generated';
import { ComponentRoundedImageFragmentDoc } from './ComponentRoundedImage.fragment.generated';
export const ComponentRoundedImageContentFragmentDoc = gql`
    fragment componentRoundedImageContent on ComponentRoundedImageContent {
  content {
    ...contentComponentItem
  }
  roundedImage {
    ...componentRoundedImage
  }
}
    ${ContentComponentItemFragmentDoc}
${ComponentRoundedImageFragmentDoc}`;